import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import Plans from '@/modules/profile/Plans'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch } from '@/redux/store'
import { PlanCode } from '@/typings/domain'
import { Stack, useLocalSearchParams } from 'expo-router'
import { useEffect } from 'react'

export default function PlansPage() {
  const dispatch = useAppDispatch()
  const { recommendedPlanCode } = useLocalSearchParams<{ recommendedPlanCode?: PlanCode }>()
  const headerLeftItems = useWebBackButton('/profile')

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
    dispatch(getUsageAndBalanceThunk())
  }, [dispatch])

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <Plans recommendedPlanCode={recommendedPlanCode} />
    </>
  )
}
